import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.black,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 40
  const h = 40
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 35c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15Z"
        stroke={color}
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M20 12.5v8.75"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 28.75A1.875 1.875 0 1 0 20 25a1.875 1.875 0 0 0 0 3.75Z"
        fill={color}
      />
    </svg>
  )
}

export default SvgComponent
